import React from 'react';
import { Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import home from "../assets/images/home.png";
import programs from "../assets/images/programs.png";
import schedule from "../assets/images/schedule.png";
import wallet from "../assets/images/wallet.png";
import tanmay from "../assets/images/tanmay.webp";

const MobileMenu = () => {
    const user = JSON.parse(localStorage.getItem("user"));

    return (
        <div className='app-container dark-foot'>
            {user.role === "Parent" ?
                <Container>
                    <div className='d-flex justify-content-between'>
                        <div className='foot-menu-item'>
                            <Link to='/dashboard'>
                                <img src={home} alt="Logo" />
                                <span className='tagname'>Home</span>
                            </Link>
                        </div>
                        <div className='foot-menu-item'>
                            <Link to='/programs'>
                                <img src={programs} alt="Logo" />
                                <span className='tagname'>Programs</span>
                            </Link>
                        </div>
                        <div className='foot-menu-item'>
                            <Link to='/schedule'>
                                <img src={schedule} alt="Logo" />
                                <span className='tagname'>Schedule</span>
                            </Link>
                        </div>
                        <div className='foot-menu-item'>
                            <Link to='/wallet'>
                                <img src={wallet} alt="Logo" />
                                <span className='tagname'>Wallet</span>
                            </Link>
                        </div>
                        <div className='foot-menu-item'>
                            <Link to='/account'>
                                <img src={tanmay} alt="Logo" />
                                <span className='tagname'>Account</span>
                            </Link>
                        </div>
                    </div>
                </Container>
                :
                <Container>
                    <div className='d-flex justify-content-between'>
                        <div className='foot-menu-item'>
                            <Link to='/teacherDashboard'>
                                <img src={home} alt="Logo" />
                                <span className='tagname'>Home</span>
                            </Link>
                        </div>
                        <div className='foot-menu-item'>
                            <Link to='/allocatedClasses'>
                                <img src={schedule} alt="Logo" />
                                <span className='tagname'>Schedule</span>
                            </Link>
                        </div>
                        <div className='foot-menu-item'>
                            <Link to='/account'>
                                <img src={tanmay} alt="Logo" />
                                <span className='tagname'>Account</span>
                            </Link>
                        </div>
                    </div>
                </Container>
            }
        </div>
    );
}

export default MobileMenu;
